/* src/components/block-stats/block-stats.component.scss */
:host {
  display: block;
}
.block-stats {
  position: relative;
  padding: 2rem 1.5rem;
  border: 1px solid var(--vwui-color-neutral-3);
  border-radius: var(--vwui--radius--md);
  box-shadow: var(--vwui-shadow-base);
}
.block-stats__summary {
  -webkit-user-select: none;
  user-select: none;
}
.block-stats__value,
.block-stats__value-of {
  display: inline-block;
  vertical-align: bottom;
  line-height: 0.6;
}
.block-stats__value {
  font-weight: 500;
  font-size: 2rem;
}
.block-stats__value-of {
  font-weight: 500;
  font-size: 1rem;
}
.block-stats__label {
  font-weight: 500;
  font-size: 0.85rem;
  line-height: 1;
  opacity: 0.35;
  margin: 0.6rem 0 0 0;
}
.block-stats__progress {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
  height: 0.3rem;
  border-radius: 0.3rem;
}
.block-stats__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: inherit;
  border-radius: inherit;
  background: var(--vwui-color-neutral-3);
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.block-stats__slot {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
/*# sourceMappingURL=block-stats.component-DUDDUD3Y.css.map */
